import { ICON_MAPPING, IconName } from './mapping';
import { classNames } from '@cotera/client/app/components/utils';

const SIZES = {
  regular: 'w-4 h-4',
  large: 'w-5 h-5',
  small: 'w-3 h-3',
};

export const Icon: React.FC<{
  icon: IconName;
  className?: string;
  size?: 'regular' | 'large' | 'small';
  style?: React.CSSProperties;
}> = ({ icon, className, size = 'regular', style }) => {
  const mapped = ICON_MAPPING[icon];

  if (mapped === undefined && import.meta.env.DEV) {
    // Falling back to a blank render is right in production, but silent in
    // development it is how `icon = 'database'` sat unnoticed on the dataset
    // actions: the row just lost its icon and started reading as a heading.
    // eslint-disable-next-line no-console
    console.warn(`Icon: no mapping for "${String(icon)}"`);
  }

  const IconComponent = mapped ?? (() => null);
  return (
    <IconComponent
      className={classNames(SIZES[size], className)}
      style={style}
    />
  );
};
